import React from "react";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import { searchText } from "../features/Blog/searchSlice";

function BlogList({ blogs }) {
  const unsearchedBlogs = blogs;
  const history = useHistory();
  const search = useSelector(searchText);

  const Blogs = unsearchedBlogs.filter((element) => {
    return (
      element.title.includes(search) ||
      element.body.includes(search) ||
      element.abstract.includes(search)
    );
  });

  return (
    <div class='container-lg mt-5'>
      <div class='row d-flex justify-content-center align-items-center g-5'>
        {Blogs.map((element) => {
          return (
            <div class='col-sm-10 col-md-9 col-xl-8 '>
              <div class='card border '>
                <div class='card-body p-5'>
                  <h3 class='text-black fw-normal text-wrap'>
                    {element.title}
                  </h3>
                  <span class='text-black-50'>
                    {element.addedAt !== undefined
                      ? element.addedAt.slice(0, 10)
                      : " "}
                    {" | By Irfan Ukani "}
                  </span>
                  <p class='mt-3 text-wrap fw-light'>{element.abstract}</p>
                  <div class='text-black-50' style={{ fontSize: "14px" }}>
                    {element.reads} Reads
                  </div>

                  <button
                    class='btn btn-outline-dark mt-2'
                    data-mdb-ripple-color='primary'
                    onClick={() => {
                      history.push(`/posts/${element.slug}`);
                    }}
                  >
                    <i class='fas fa-add'></i> &nbsp; Read More
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default BlogList;
